import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

export const PricingBox = styled(Box)`
  margin-bottom: 4px;

  @media (min-width: 993px) {
    margin-bottom: 8px;
  }
`